module.exports = __webpack_public_path__ + "static/media/galerija_2023 (12).f7b968f1.png";